import { gql } from '@apollo/client';
import { Box, VStack } from '@chakra-ui/react';
import { DocumentNode } from 'graphql';
import * as React from 'react';

import { EventListItem } from '@/components/EventListItem';
import { useCommentActions } from '@/components/Post/hooks/useCommentActions';

import { EventAlert_PostFragment_EventAlert } from './graphql-types/EventAlert_PostFragment';

import { Comments } from '../Comments';
import { CreateComment, CreateComment_postFragment } from '../CreateComment';
import { LikeCommentFooter } from '../LikeCommentFooter';
import { Header } from './components/Header';

export const EventAlert: React.FC<{
  eventAlert: EventAlert_PostFragment_EventAlert;
}> & {
  postFragment: DocumentNode;
} = ({ eventAlert }) => {
  const {
    ref,
    focusAndScrollToRef,
    expandOrFocusAndScrollToRef,
    isActive,
    setIsActive,
    ...expandProps
  } = useCommentActions({
    post: eventAlert,
  });

  // TODO: this field shouldnt be optional
  if (!eventAlert.event) return null;

  return (
    <Box p="4">
      <Header eventAlert={eventAlert} mb="4" />
      <EventListItem event={eventAlert.event} shadow="xs" />
      <VStack spacing="4" width="full" align="start" mt="4">
        <LikeCommentFooter
          post={eventAlert}
          mt="4"
          onClickComment={focusAndScrollToRef}
          onClickCommentCount={expandOrFocusAndScrollToRef}
        />
        <Comments post={eventAlert} expandProps={expandProps} />
        <CreateComment
          post={eventAlert}
          ref={ref}
          isActive={isActive}
          setIsActive={setIsActive}
        />
      </VStack>
    </Box>
  );
};

EventAlert.postFragment = gql`
  fragment EventAlert_PostFragment on PostV2 {
    ... on EventAlert {
      _id
      alertType
      event {
        _id
        ...EventListItem_EventFragment
      }
      ...Header_EventAlertFragment
      ...LikeCommentFooter_PostFragment
      ...Comments_PostFragment
      ...CreateComment_PostFragment
      ...useCommentActions_PostFragment
    }
  }
  ${EventListItem.eventFragment}
  ${Header.eventAlertFragment}
  ${LikeCommentFooter.postFragment}
  ${Comments.postFragment}
  ${CreateComment_postFragment}
  ${useCommentActions.postFragment}
`;
